module.exports = __webpack_public_path__ + "img/13-3.72e320bd.png";